export function SectionEyebrow({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.16em] text-cyan">
      <span className="h-1.5 w-1.5 rounded-full bg-cyan shadow-[0_0_0_3px_rgba(37,199,255,0.2)]" />
      {children}
    </span>
  );
}
